import { render } from "./VipModal.vue?vue&type=template&id=6f19613a&scoped=true"
import script from "./VipModal.vue?vue&type=script&lang=js"
export * from "./VipModal.vue?vue&type=script&lang=js"

import "./VipModal.vue?vue&type=style&index=0&id=6f19613a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f19613a"]])

export default __exports__